module.exports = __webpack_public_path__ + "img/btn_floating_opened.167d6803.svg";